document.querySelectorAll('[data-review-sort]').forEach((select) => {
  const list = select.closest('.product-specs-reviews')?.querySelector('[data-review-list]');
  if (!list) return;

  select.addEventListener('change', () => {
    const cards = [...list.querySelectorAll('.review-card')];
    cards.sort((a, b) => {
      if (select.value === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating);
      return Number(a.dataset.index) - Number(b.dataset.index);
    });
    cards.forEach((card) => list.appendChild(card));
  });
});
